
import React, { useEffect, useState } from "react";
import { useFormik, FormikProvider, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as bie from "react-bootstrap";
import { FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { failureAlert, successAlert2, successAlertRefresh } from "../CommonUtils/SweetAlerts";

import * as Yup from "yup";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, AllowFloats } from "../CommonUtils/CommonValidations";
// import allowNumbersOnly, { allowAlphabetAndSpacesOnly, AllowFloats } from "../CommonUtils/CommonValidations";

const InfrastructureForm = ({ goNext }) => {
    const validationSchema = Yup.object({
        // placeTown: Yup.string().required(ERROR_MSG),
        totalLandArea: Yup.string().required(ERROR_MSG),
        landOwnership: Yup.string().required(ERROR_MSG),
        surveyNo: Yup.string().required(ERROR_MSG),
        landRegNo: Yup.string().required(ERROR_MSG),
        totalBuiltupArea: Yup.string().required(ERROR_MSG),
        noOfFloors: Yup.string().required(ERROR_MSG),
        yearOfConstruction: Yup.string().required(ERROR_MSG),
        occupCertNo: Yup.string().required(ERROR_MSG),
        buildingPlanApproveNo: Yup.string().required(ERROR_MSG),
        planApprovedBy: Yup.string().required(ERROR_MSG),
        fireSafetyCertNo: Yup.string().required(ERROR_MSG),

        libraryAre: Yup.string().required(ERROR_MSG),
        noBookLibrary: Yup.string().required(ERROR_MSG),
        noOfJournals: Yup.string().required(ERROR_MSG),
        readingRromCapacity: Yup.string().required(ERROR_MSG),

        totalComputers: Yup.string().required(ERROR_MSG),
        totalComputersWithInternet: Yup.string().required(ERROR_MSG),
        internetBandwith: Yup.string().required(ERROR_MSG),
        seminarhallCapacity: Yup.string().required(ERROR_MSG),

        boysToiletBlocks: Yup.string().required(ERROR_MSG),
        girlsToiletBlocks: Yup.string().required(ERROR_MSG),
        drinkingWaterFacility: Yup.string().required(ERROR_MSG),
        canteenFacility: Yup.string().required(ERROR_MSG),

        playgroundArea: Yup.string().required(ERROR_MSG),
        hostelFacility: Yup.string().required(ERROR_MSG),
        hostelCapacity: Yup.string().required(ERROR_MSG),
        transportFacility: Yup.string().required(ERROR_MSG),

        sanctionElectricLoad: Yup.string().required(ERROR_MSG),
        connectedLoad: Yup.string().required(ERROR_MSG),
        generaterPower: Yup.string().required(ERROR_MSG),
        solarPower: Yup.string().required(ERROR_MSG),

        distanceNearTown: Yup.string().required(ERROR_MSG),
        nearestRailwaystation: Yup.string().required(ERROR_MSG),
        nearestBusStop: Yup.string().required(ERROR_MSG),
        approachRoad: Yup.string().required(ERROR_MSG),
    })
    const InstitutionFormik = useFormik({
        initialValues: {

            totalLandArea: "",
            landOwnership: "",
            surveyNo: "",
            landRegNo: "",

            totalBuiltupArea: "",
            noOfFloors: "",
            yearOfConstruction: "",
            occupCertNo: "",
            buildingPlanApproveNo: "",
            planApprovedBy: "",
            fireSafetyCertNo: "",

            libraryAre: "",
            noBookLibrary: "",
            noOfJournals: "",
            readingRromCapacity: "",

            totalComputers: "",
            totalComputersWithInternet: "",
            internetBandwith: "",
            seminarhallCapacity: "",

            boysToiletBlocks: "",
            girlsToiletBlocks: "",
            drinkingWaterFacility: "",
            canteenFacility: "",

            playgroundArea: "",
            hostelFacility: "",
            hostelCapacity: "",
            transportFacility: "",

            sanctionElectricLoad: "",
            connectedLoad: "",
            generaterPower: "",
            solarPower: "",

            distanceNearTown: "",
            nearestRailwaystation: "",
            nearestBusStop: "",
            approachRoad: "",

            classRoomlist: [
                {
                    courseId: "",
                    roomName: "",
                    classType: "",
                    length: "",
                    breadth: "",
                    area: "",
                    capacity: "",
                    floorNo: ""
                }
            ],

            labsList: [
                {
                    labName: "",
                    courseId: "",
                    area: "",
                    noOfSeats: "",
                    capacity: "",
                    majorEquipment: ""
                }
            ]

        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: (val) => {

            // const formattedValues = {
            //     ...val,
            //     district: parseInt(val.district, 10),
            //     mandal: parseInt(val.mandal, 10),
            //     pincode: parseInt(val.pincode, 10),
            //     stdCode: parseInt(val?.stdCode, 10),

            // };

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `saveInfrastructureDetails`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc)
                            goNext();

                        }
                        else if (res?.data?.scode === '02') {
                            Swal.fire(res?.data?.sdesc, '', 'error').then((res) => {
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }


    });




    const [clgdata, setClgdata] = useState([]);
    function GetInfraStructureData() {
        CommonAxiosGet(`${config.url.FAC_URL}getInfrastructureDetails`).then((res) => {
            if (res?.data?.scode === '01') {

                const infra = res?.data?.infra?.[0] || {};
                const classroom = res?.data?.classroom || [];
                const labs = res?.data?.labs || [];

                InstitutionFormik.setValues({

                    totalLandArea: infra?.total_land_area || "",
                    landOwnership: infra?.land_ownership || "",
                    surveyNo: infra?.survey_no || "",
                    landRegNo: infra?.land_reg_no || "",

                    totalBuiltupArea: infra?.total_builtup_area || "",
                    noOfFloors: infra?.no_of_floors || "",
                    yearOfConstruction: infra?.year_of_construction || "",
                    occupCertNo: infra?.occup_cert_no || "",
                    buildingPlanApproveNo: infra?.building_plan_approve_no || "",
                    planApprovedBy: infra?.plan_approved_by || "",
                    fireSafetyCertNo: infra?.firesafety_cert_no || "",

                    libraryAre: infra?.library_area || "",
                    noBookLibrary: infra?.no_book_library || "",
                    noOfJournals: infra?.no_of_journals || "",
                    readingRromCapacity: infra?.reading_room_capacity || "",

                    totalComputers: infra?.total_computers || "",
                    totalComputersWithInternet: infra?.total_computers_with_internet || "",
                    internetBandwith: infra?.internet_bandwith || "",
                    seminarhallCapacity: infra?.seminarhall_capacity || "",

                    boysToiletBlocks: infra?.boys_toilet_blocks || "",
                    girlsToiletBlocks: infra?.girls_toilet_blocks || "",
                    drinkingWaterFacility: infra?.drinking_water_facility || "",
                    canteenFacility: infra?.canteen_facility || "",

                    playgroundArea: infra?.playground_area || "",
                    hostelFacility: infra?.hostel_facility || "",
                    hostelCapacity: infra?.hostel_capacity || "",
                    transportFacility: infra?.transport_facility || "",

                    sanctionElectricLoad: infra?.sanction_electric_load || "",
                    connectedLoad: infra?.connected_load || "",
                    generaterPower: infra?.generater_power || "",
                    solarPower: infra?.solar_power || "",

                    distanceNearTown: infra?.distance_near_town || "",
                    nearestRailwaystation: infra?.nearest_railwaystation || "",
                    nearestBusStop: infra?.nearest_bus_stop || "",
                    approachRoad: infra?.approach_road || "",

                    classRoomlist: classroom.map((item) => ({
                        courseId: item?.course_id || "",
                        roomName: item?.room_name || "",
                        classType: item?.class_type || "",
                        length: item?.length || "",
                        breadth: item?.breadth || "",
                        area: item?.area || "",
                        capacity: item?.capacity || "",
                        floorNo: item?.floor_no || ""
                    })),

                    labsList: labs.map((item) => ({
                        labName: item?.lab_name || "",
                        courseId: item?.course_id || "",
                        area: item?.area || "",
                        noOfSeats: item?.no_of_seats || "",
                        capacity: item?.capacity || "",
                        majorEquipment: item?.major_equipment || ""
                    }))

                });

            } else {
                setClgdata([]);
            }
        });
    }
    // const [program, setProgram] = useState([])
    // function GetProgram() {
    //     let url = config.url.FAC_URL + `getCourseGroupList`
    //     CommonAxiosGet(url).then((res) => {
    //         if (res?.data?.scode === '01') {
    //             setProgram(res?.data?.getCourseGroupList)
    //         }
    //         else {
    //             setProgram([])
    //         }
    //     })
    // }

    const [clgcrs, setClgcrs] = useState([]);
    function GetCollegeCourses() {
        let url = config.url.FAC_URL + `getCollegeCourses`
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setClgcrs(res?.data?.data);
            }
            else {
                setClgcrs([]);
            }
        })
    }
    const calculateArea = (index, length, breadth) => {
        const area = (Number(length) || 0) * (Number(breadth) || 0);
        InstitutionFormik?.setFieldValue(`classRoomlist[${index}].area`, area);
    };

    useEffect(() => {
        // GetProgram();
        GetCollegeCourses();
        GetInfraStructureData();
    }, [])
    return (
        <>

            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <h5 className="mb-3 innerheader-new"><span>Infrastructure Details</span></h5>
                    <FormikProvider value={InstitutionFormik}>
                        <Form onSubmit={InstitutionFormik.handleSubmit}
                            onChange={InstitutionFormik.handleChange}
                        >

                            <h5 className="mb-3 innerheader-new"><span>Land Details</span></h5>


                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Total Land Area (Sq.m)</label>
                                    <Field name="totalLandArea" className="form-control" maxLength={15} onKeyPress={AllowFloats} />
                                    <ErrorMessage name="totalLandArea" component="div" className="text-danger extra-small mt-1"
                                    />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Land Ownership Type</label>
                                    <Field as="select" name="landOwnership" className="select-input">
                                        <option value="">--Select--</option>
                                        <option value="Own">Own</option>
                                        <option value="Lease">Lease</option>
                                    </Field>
                                    <ErrorMessage name="landOwnership" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Survey / Sy No</label>
                                    <Field name="surveyNo" className="form-control" maxLength={20} />
                                    <ErrorMessage name="surveyNo" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Land Registration No</label>
                                    <Field name="landRegNo" className="form-control" maxLength={20} />
                                    <ErrorMessage name="landRegNo" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>





                            <h5 className="mb-3 innerheader-new"><span>Built-up Area  Details</span></h5>


                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Total Built-up Area</label>
                                    <Field name="totalBuiltupArea" className="form-control" onKeyPress={AllowFloats} />
                                    <ErrorMessage name="totalBuiltupArea" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>No of Floors</label>
                                    <Field name="noOfFloors" className="form-control" maxLength={3} onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="noOfFloors" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Year of Construction</label>
                                    <Field as="select" name="yearOfConstruction" className="select-input">
                                        <option value=''>--select--</option>
                                        {[...Array(new Date().getFullYear() - 1947 + 1).keys()]
                                            .map((i) => {
                                                const year = 1947 + i;
                                                return (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                );
                                            })}


                                    </Field>
                                    <ErrorMessage name="yearOfConstruction" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Occupancy Certificate No</label>
                                    <Field name="occupCertNo" className="form-control" />
                                    <ErrorMessage name="occupCertNo" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>

                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Building Plan Approval No</label>
                                    <Field name="buildingPlanApproveNo" className="form-control" />
                                    <ErrorMessage name="buildingPlanApproveNo" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Approved By</label>
                                    <Field name="planApprovedBy" className="form-control" onKeyPress={allowAlphabetAndSpacesOnly}
                                    />
                                    <ErrorMessage name="buildingPlanApproveNo" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Fire Safety Certificate No</label>
                                    <Field name="fireSafetyCertNo" className="form-control" />
                                    <ErrorMessage name="buildingPlanApproveNo" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>

                            <h5 className="mb-3 innerheader-new"><span>Tutorial Rooms / Classrooms</span></h5>


                            <div className="table-responsive">

                                <FieldArray name="classRoomlist">
                                    {({ push, remove }) => (

                                        <table table className="table table-bordered mt-2 ">

                                            <thead className="table-primary">
                                                <tr >
                                                    <th>S.No</th>
                                                    {/* <th>Programme / Course</th> */}
                                                    <th>Course</th>

                                                    <th>Room No./Name</th>
                                                    <th>Type</th>
                                                    <th>Length (m)</th>
                                                    <th>Breadth (m)</th>
                                                    <th>Area (Sq.m)</th>
                                                    <th>Capacity (seats)</th>
                                                    <th>Floor No.</th>
                                                    <th style={{ width: "60px" }}>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {InstitutionFormik?.values?.classRoomlist?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>

                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`classRoomlist[${index}].courseId`}
                                                                className="form-control form-control-sm"

                                                            >
                                                                <option value="">---select---</option>
                                                                {clgcrs && clgcrs?.map((pp, i) => (
                                                                    <option value={pp?.course_id} key={i}>{pp?.course_name}</option>
                                                                ))}
                                                            </Field>
                                                            <ErrorMessage name={`classRoomlist[${index}].courseId`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`classRoomlist[${index}].roomName`}
                                                                className="form-control form-control-sm"
                                                                placeholder="Room No./Name"
                                                            />
                                                            <ErrorMessage name={`classRoomlist[${index}].roomName`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`classRoomlist[${index}].classType`}
                                                                className="form-select form-select-sm"
                                                            >
                                                                <option value="">--Select--</option>
                                                                <option value="Lecture Room">Lecture Room</option>
                                                                <option value="Tutorial Room">Tutorial Room</option>
                                                                <option value="Lab">Lab</option>
                                                                <option value="Seminar Hall">Seminar Hall</option>
                                                            </Field>
                                                            <ErrorMessage name={`classRoomlist[${index}].classType`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="number"
                                                                name={`classRoomlist[${index}].length`}
                                                                className="form-control form-control-sm"
                                                                onChange={(e) => {
                                                                    const length = e.target.value;

                                                                    InstitutionFormik?.setFieldValue(`classRoomlist[${index}].length`, length);

                                                                    const breadth = InstitutionFormik?.values?.classRoomlist[index]?.breadth;

                                                                    calculateArea(index, length, breadth);
                                                                }}
                                                            />
                                                            <ErrorMessage name={`classRoomlist[${index}].length`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="number"
                                                                name={`classRoomlist[${index}].breadth`}
                                                                className="form-control form-control-sm"
                                                                onChange={(e) => {
                                                                    const breadth = e.target.value;

                                                                    InstitutionFormik?.setFieldValue(`classRoomlist[${index}].breadth`, breadth);

                                                                    const length = InstitutionFormik?.values?.classRoomlist[index]?.length;

                                                                    calculateArea(index, length, breadth);
                                                                }}
                                                            />
                                                            <ErrorMessage name={`classRoomlist[${index}].breadth`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            {/* <Field
                                                                type="number"
                                                                name={`classRoomlist[${index}].area`}
                                                                className="form-control form-control-sm"
                                                            /> */}
                                                            <Field
                                                                type="number"
                                                                name={`classRoomlist[${index}].area`}
                                                                className="form-control form-control-sm"
                                                                readOnly
                                                            />
                                                            <ErrorMessage name={`classRoomlist[${index}].area`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="number"
                                                                name={`classRoomlist[${index}].capacity`}
                                                                className="form-control form-control-sm"
                                                            />
                                                            <ErrorMessage name={`classRoomlist[${index}].capacity`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="number"
                                                                name={`classRoomlist[${index}].floorNo`}
                                                                className="form-control form-control-sm"
                                                            />
                                                            <ErrorMessage name={`classRoomlist[${index}].floorNo`} component="div" className="text-danger" />

                                                        </td>

                                                        <td className="text-center">

                                                            {InstitutionFormik?.values?.classRoomlist?.length > 1 && (

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link text-danger p-0"
                                                                    onClick={() => remove(index)}
                                                                >
                                                                    <FaTrashAlt size={16} />
                                                                </button>

                                                            )}

                                                        </td>

                                                    </tr>
                                                ))}

                                            </tbody>

                                            <tfoot>
                                                <tr>
                                                    <td colSpan="10" className="text-end">

                                                        <bie.Button
                                                            variant="success"
                                                            size="sm"
                                                            onClick={() => push({
                                                                courseId: "",
                                                                roomName: "",
                                                                classType: "",
                                                                length: "",
                                                                breadth: "",
                                                                area: "",
                                                                capacity: "",
                                                                floorNo: ""
                                                            })}
                                                        >
                                                            <FaPlusCircle className="me-2" />
                                                            Add Room
                                                        </bie.Button>

                                                    </td>
                                                </tr>
                                            </tfoot>

                                        </table>

                                    )}
                                </FieldArray>

                            </div>
                            <h5 className="mb-3 innerheader-new"><span>Laboratories & Workshops
                            </span></h5>

                            {/* COMMON FACILITIES */}
                            <div className="table-responsive">

                                <FieldArray name="labsList">
                                    {({ push, remove }) => (

                                        <table className="table table-bordered mt-2 ">

                                            <thead className="table-primary">
                                                <tr>
                                                    <th style={{ width: "60px" }}>S.No</th>
                                                    <th>Course</th>

                                                    <th>Lab Name</th>
                                                    <th>Area (Sq.m)</th>
                                                    <th>No. of Equipment Sets</th>
                                                    <th>Student Capacity</th>
                                                    <th>Major Equipment (brief)</th>
                                                    <th style={{ width: "60px" }}>Action</th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {InstitutionFormik?.values?.labsList?.map((item, index) => (
                                                    <tr key={index}>

                                                        <td className="text-center fw-bold">
                                                            {index + 1}
                                                        </td>

                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`labsList[${index}].courseId`}
                                                                className="form-control form-control-sm"
                                                            >
                                                                <option value="">--Select--</option>

                                                                {clgcrs && clgcrs?.map((pp, i) => (
                                                                    <option value={pp?.course_id} key={i}>{pp?.course_name}</option>
                                                                ))}
                                                            </Field>
                                                            <ErrorMessage name={`labsList[${index}].courseId`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="text"
                                                                name={`labsList[${index}].labName`}
                                                                className="form-control form-control-sm"
                                                            />
                                                            <ErrorMessage name={`labsList[${index}].labName`} component="div" className="text-danger" />


                                                        </td>


                                                        <td>
                                                            <Field
                                                                type="number"
                                                                name={`labsList[${index}].area`}
                                                                className="form-control form-control-sm"
                                                            />
                                                            <ErrorMessage name={`labsList[${index}].area`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="number"
                                                                name={`labsList[${index}].noOfSeats`}
                                                                className="form-control form-control-sm"
                                                            />
                                                            <ErrorMessage name={`labsList[${index}].noOfSeats`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                type="number"
                                                                name={`labsList[${index}].capacity`}
                                                                className="form-control form-control-sm"
                                                            />
                                                            <ErrorMessage name={`labsList[${index}].capacity`} component="div" className="text-danger" />

                                                        </td>

                                                        <td>
                                                            <Field
                                                                as="textarea"
                                                                name={`labsList[${index}].majorEquipment`}
                                                                className="form-control form-control-sm"
                                                            />
                                                            <ErrorMessage name={`labsList[${index}].majorEquipment`} component="div" className="text-danger" />

                                                        </td>

                                                        <td className="text-center">

                                                            {InstitutionFormik?.values?.labsList?.length > 1 && (

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link text-danger p-0"
                                                                    onClick={() => remove(index)}
                                                                >
                                                                    <FaTrashAlt size={16} />
                                                                </button>

                                                            )}

                                                        </td>

                                                    </tr>
                                                ))}

                                            </tbody>

                                            <tfoot>
                                                <tr>
                                                    <td colSpan="8" className="text-end">

                                                        <bie.Button
                                                            variant="success"
                                                            size="sm"
                                                            onClick={() => push({
                                                                labName: "",
                                                                courseId: "",
                                                                area: "",
                                                                noOfSeats: "",
                                                                capacity: "",
                                                                majorEquipment: ""
                                                            })}
                                                        >
                                                            <FaPlusCircle className="me-2" />
                                                            Add Lab
                                                        </bie.Button>

                                                    </td>
                                                </tr>
                                            </tfoot>

                                        </table>

                                    )}
                                </FieldArray>

                            </div>

                            <h5 className="mb-3 innerheader-new"><span>Common Facilities</span></h5>

                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Library Area (Sq. m.)</label>
                                    <Field name="libraryAre" className="form-control" onKeyPress={AllowFloats} maxLength={16} />
                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>No. of Books in Library</label>
                                    <Field name="noBookLibrary" className="form-control" onKeyPress={allowNumbersOnly} maxLength={9} />
                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>No. of Journals / Periodicals</label>
                                    <Field name="noOfJournals" className="form-control" onKeyPress={allowNumbersOnly} maxLength={10} />
                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Reading Room Capacity (seats)</label>
                                    <Field name="readingRromCapacity" className="form-control" onKeyPress={allowNumbersOnly} maxLength={10} />
                                </bie.Col>

                            </bie.Row>

                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>No. of Computers (Total)</label>
                                    <Field name="totalComputers" className="form-control" onKeyPress={allowNumbersOnly} />
                                    <ErrorMessage name="totalComputers" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>No. of Computers with Internet</label>
                                    <Field name="totalComputersWithInternet" className="form-control" onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="totalComputersWithInternet" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Internet Bandwidth (Mbps)</label>
                                    <Field name="internetBandwith" className="form-control" />
                                    <ErrorMessage name="internetBandwith" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Seminar Hall Capacity (seats)</label>
                                    <Field name="seminarhallCapacity" className="form-control" onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="seminarhallCapacity" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>

                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Boys' Toilet Blocks</label>
                                    <Field name="boysToiletBlocks" className="form-control" type="number" />
                                    <ErrorMessage name="boysToiletBlocks" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Girls' Toilet Blocks</label>
                                    <Field name="girlsToiletBlocks" className="form-control" type="number" />
                                    <ErrorMessage name="girlsToiletBlocks" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Drinking Water Facility</label>
                                    <Field as="select" name="drinkingWaterFacility" className="select-input">
                                        <option value="">Select</option>
                                        <option value="Available">Available</option>
                                        <option value="Not Available">Not Available</option>
                                    </Field>
                                    <ErrorMessage name="drinkingWaterFacility" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Canteen / Cafeteria</label>
                                    <Field as="select" name="canteenFacility" className="select-input">
                                        <option value="">Select</option>
                                        <option value="Available">Available</option>
                                        <option value="Not Available">Not Available</option>
                                    </Field>
                                    <ErrorMessage name="canteenFacility" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>

                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Sports / Playground Area (Sq.m)</label>
                                    <Field name="playgroundArea" className="form-control" type="number" />
                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Hostel Facility</label>
                                    <Field as="select" name="hostelFacility" className="select-input"
                                        onChange={(e) => { InstitutionFormik?.setFieldValue("hostelCapacity", '') }}>
                                        <option value="">Select</option>
                                        <option value="Available">Available</option>
                                        <option value="Not Available">Not Available</option>
                                    </Field>
                                    <ErrorMessage name="hostelFacility" component="div" className="text-danger" />

                                </bie.Col>
                                {InstitutionFormik?.values?.hostelFacility == "Available" && (

                                    <bie.Col lg={3}>
                                        <label>Hostel Capacity (if any)</label>
                                        <Field name="hostelCapacity" className="form-control" type="number" />
                                    </bie.Col>
                                )}
                                <bie.Col lg={3}>
                                    <label>Transport Facility</label>
                                    <Field as="select" name="transportFacility" className="select-input">
                                        <option value="">Select</option>
                                        <option value="Available">Available</option>
                                        <option value="Not Available">Not Available</option>
                                    </Field>
                                    <ErrorMessage name="transportFacility" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>


                            {/* POWER UTILITIES */}


                            <h5 className="mb-3 innerheader-new"><span>Power & Utilities</span></h5>

                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Sanctioned Electrical Load (KW)</label>
                                    <Field name="sanctionElectricLoad" className="form-control" type="number" />
                                    <ErrorMessage name="sanctionElectricLoad" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Connected Load (KW)</label>
                                    <Field name="connectedLoad" className="form-control" type="number" />
                                    <ErrorMessage name="connectedLoad" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Generator / Backup Power (KVA)</label>
                                    <Field name="generaterPower" className="form-control" type="number" />
                                    <ErrorMessage name="generaterPower" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Solar Power (KW)</label>
                                    <Field name="solarPower" className="form-control" type="number" />
                                    <ErrorMessage name="solarPower" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>


                            <h5 className="mb-3 innerheader-new"><span>Additional Details (New Institution / Location Change)</span></h5>

                            <bie.Row className="mb-3">

                                <bie.Col lg={3}>
                                    <label>Distance from Nearest Town (km)</label>
                                    <Field type="text" name="distanceNearTown" className="form-control" onKeyPress={allowNumbersOnly}
                                    />
                                    <ErrorMessage name="distanceNearTown" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Nearest Railway Station</label>
                                    <Field name="nearestRailwaystation" className="form-control" placeholder="Station name" onKeyPress={allowAlphabetAndSpacesOnly}
                                    />
                                    <ErrorMessage name="nearestRailwaystation" component="div" className="text-danger" />

                                </bie.Col>

                                <bie.Col lg={3}>
                                    <label>Nearest Bus Stop</label>
                                    <Field name="nearestBusStop" className="form-control" placeholder="Bus stop name" onKeyPress={allowAlphabetAndSpacesOnly} />
                                    <ErrorMessage name="nearestBusStop" component="div" className="text-danger" />

                                </bie.Col>



                                <bie.Col lg={3}>
                                    <label>Description of Accessibility / Approach Road</label>
                                    <Field
                                        as="textarea"
                                        name="approachRoad"
                                        className="form-control"
                                        placeholder="Describe road connectivity, public transport..."
                                        onKeyPress={allowAlphabetAndSpacesOnly}
                                    />
                                    <ErrorMessage name="approachRoad" component="div" className="text-danger" />

                                </bie.Col>

                            </bie.Row>
                            <bie.Row className="mt-3">
                                <bie.Col className="text-end">
                                    <button type="submit" className="btn btn-primary">
                                        Save
                                        {/* &amp; Next → */}
                                    </button>
                                </bie.Col>
                            </bie.Row>



                        </Form>

                    </FormikProvider>

                </div>
            </div >
        </>

    );

};

export default InfrastructureForm;